<div class="sm:flex md:flex flex-col w-full lg:hidden xl:hidden relative mb-8">
  <div class="welcome-banner flex justify-center pt-4">
    <img class="banner-image" src="assets/svgs/banner-mobile.svg" alt="welcome-banner">
  </div>
  <div class="flex justify-center absolute w-full top-40">
    <img class="welcome-icon" src="assets/svgs/welcome-icon.svg" alt="welcome-icon">
  </div>
</div>